import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';

import Photography from './Photography';
import Projects, { projectList } from './Projects';

const featuredPhotos = [
  { src: '/images_display/img_1.JPG', alt: 'Desert road at sunset' },
  { src: '/images_display/img_8.JPG', alt: 'Seagull standing on an ocean pier' },
  { src: '/images_display/img_13.JPG', alt: 'Snowcapped mountain above a lakeside town' },
];

function App() {
  return (
    <Router>
      <div className="App">
        <NavBar />

        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/apps" element={<Projects />} />
            <Route path="/photography" element={<Photography />} />
          </Routes>
        </main>

        <footer>
          <small>© {new Date().getFullYear()} Shabit Bhatt</small>
        </footer>
      </div>
    </Router>
  );
}

function NavBar() {
  return (
    <header>
      <nav aria-label="Primary">
        <ul className="nav">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/photography">Photography</Link></li>
          <li><Link to="/projects">Projects</Link></li>
        </ul>
      </nav>
    </header>
  );
}

function Home() {
  const featuredProjects = projectList.filter((project) => project.featured).slice(0, 3);

  return (
    <div className="page-shell">
      <section id="title" className="hero" aria-label="Intro">
        <p className="eyebrow">Software Engineer</p>
        <h1>Shabit Bhatt</h1>
        <img
          src="/images_display/IMG_5265.JPG"
          alt="Shabit standing by the water at sunset"
          className="hero-portrait"
        />
        <p className="hero-copy">
          I like to build software, take pictures, and look at stars...
        </p>
        <p className="hero-copy muted-copy">
          I recently graduated from UConn with a degree
          in Computer Science & Engineering and minors in Mathematics and
          Physics.
        </p>
      </section>

      <section id="photography" className="home-section" aria-labelledby="photo-title">
        <div className="section-copy">
          <p className="eyebrow">Photography</p>
          <h2 id="photo-title">Gallery Snapshot</h2>
          <p>
            The world as seen through my camera lens
          </p>
        </div>

        <div className="photo-preview-grid" aria-hidden="true">
          {featuredPhotos.map((photo) => (
            <div key={photo.src} className="photo-preview-card">
              <img src={photo.src} alt={photo.alt} className="photo-preview-image" loading="lazy" />
            </div>
          ))}
        </div>

        <Link to="/photography" className="see_more">
          View full gallery &rarr;
        </Link>
      </section>

      <section id="projects" className="home-section" aria-labelledby="projects-title">
        <div className="section-copy">
          <p className="eyebrow">Projects</p>
          <h2 id="projects-title">Some things I've built</h2>
          <p>
            A mix of systems engineering, C++ projects, and small web-apps.
          </p>
        </div>

        <div className="project-preview-grid">
          {featuredProjects.map((project) => (
            <article key={project.title} className="project-preview-card">
              <h3>{project.title}</h3>
              <p>{project.summary}</p>
              <p className="project-stack">{project.stack.join(' · ')}</p>
            </article>
          ))}
        </div>

        <Link to="/projects" className="see_more">
          Open projects page &rarr;
        </Link>
      </section>

      <section id="contact" className="home-section contact-section" aria-labelledby="contact-title">
        <div className="section-copy">
          <p id="contact-title" className="eyebrow">Contact</p>
        </div>

        <div className="contact-icons">
          <a
            href="mailto:bhattshabit@gmail.com"
            className="contact-icon"
            aria-label="Email"
          >
            <FaEnvelope />
          </a>
          <a
            href="https://linkedin.com/in/shabit-bhatt-0ab100199"
            className="contact-icon"
            aria-label="LinkedIn"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://github.com/s-b-i-t"
            className="contact-icon"
            aria-label="GitHub"
            target="_blank"
            rel="noreferrer"
          >
            <FaGithub />
          </a>
        </div>

        <a className="contact-email" href="mailto:bhattshabit@gmail.com">
          bhattshabit@gmail.com
        </a>
      </section>
    </div>
  );
}

export default App;
